import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { convertToNumber, stringToInt, formatMoney } from '@iso/lib/helpers/utility';

const borderColor = '#000000'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#000000',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 11,
        fontStyle: 'bold',
    },
    description: {
        width: '62%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
    },
    qtd: {
        width: '8%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
    },
    discountTotal: {
        width: '13%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
    },
    total: {
        width: '17%',
        textAlign: 'right',
        paddingRight: 8,
        fontFamily:'Helvetica-Bold'
    },
  });


    const ProposalTableFooter = ({ items }) => {
        let discountTotal = 0;
        let qtdTotal = 0;
        let totalValue = 0;

        let qtd;
        let price;
        let discount;
    
        items.forEach((item) => {
            if( typeof item.item._id !== 'undefined') {
                qtd = parseFloat(item.quantity+'')

                // console.log('item.unit_price: ', item.unit_price);
                // console.log('typeof item.unit_price: ', typeof item.unit_price);    

                price = (typeof item.unit_price === 'string') ? convertToNumber(item.unit_price, 5) : item.unit_price;
                discount = (typeof item.discount === 'string') ? convertToNumber(item.discount, 5) : item.discount;

                // console.log('qtd: ', qtd);
                // console.log('price: ', price);
                // console.log('discount: ', discount);

                discountTotal += qtd * discount;
                qtdTotal += qtd;
                
                totalValue += qtd * price - qtd * discount;
            }
        });
    
        const formattedDiscountTotal = formatMoney(discountTotal+'');
        const formattedTotalValue = formatMoney(totalValue+'');
    
        return (
        <View style={styles.row}>
            <Text style={styles.description}>TOTAL</Text>
            <Text style={styles.qtd}>{qtdTotal}</Text>
            <Text style={styles.discountTotal}>R$ {formattedDiscountTotal}</Text>
            <Text style={styles.total}>R$ {formattedTotalValue}</Text>
        </View>
        );
    };
  
  export default ProposalTableFooter